import { select, call } from 'redux-saga/effects'

// Take care of boring stuff:
// - inject access token from redux store
// TODO:
// - and dispatch shitty logout on 401
export function* authApiCall(apiFn, ...args) {
  const token = yield select(state => state.auth.accessToken)
  return yield call(apiFn(token), ...args)
}



// WEBPACK FOOTER //
// ./src/saga/helpers.js